import React from 'react';
import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

const buttonClasses = cva(
  'inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed',
  {
    variants: {
      variant: {
        primary: 'hover:opacity-90 focus:ring-blue-500',
        secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-500',
        outline: 'border-2 bg-transparent hover:bg-opacity-10 focus:ring-blue-500',
      },
      size: {
        small: 'text-sm px-3 py-1.5',
        medium: 'text-base px-4 py-2',
        large: 'text-lg px-6 py-3',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'medium',
    },
  }
);

const Button = ({
  text = "Add to cart",
  text_font_size = "16",
  text_font_family = "Lato",
  text_font_weight = "700",
  text_line_height = "20px",
  text_text_align = "left",
  text_color = "#ffffff",
  fill_background_color = "#5b9a85",
  border_border_radius = "8px",
  
  effect_box_shadow,
  fill_background,
  border_border,
  border_border_image,
  layout_align_self,
  layout_width,
  padding,
  margin,
  position,
  layout_gap,
  
  variant,
  size,
  disabled = false,
  loading = false, // ✅ خاصية loading
  className,
  children,
  onClick,
  type = "button",
  ...props
}) => {
  const hasValidBoxShadow = effect_box_shadow && effect_box_shadow.trim() !== '';
  const hasValidBackground = fill_background && fill_background.trim() !== '';
  const hasValidBorder = border_border && border_border.trim() !== '';
  const hasValidBorderImage = border_border_image && border_border_image.trim() !== '';
  const hasValidAlignSelf = layout_align_self && layout_align_self.trim() !== '';
  const hasValidWidth = layout_width && layout_width.trim() !== '';
  const hasValidPadding = padding && padding.trim() !== '';
  const hasValidMargin = margin && margin.trim() !== '';
  const hasValidPosition = position && position.trim() !== '';
  const hasValidGap = layout_gap && layout_gap.trim() !== '';

  const optionalClasses = [
    hasValidBoxShadow ? `shadow-[${effect_box_shadow}]` : '',
    hasValidAlignSelf ? `self-${layout_align_self}` : '',
    hasValidWidth ? `w-[${layout_width}]` : '',
    hasValidPadding ? `p-[${padding}]` : '',
    hasValidMargin ? `m-[${margin}]` : '',
    hasValidPosition ? position : '',
    hasValidGap ? `gap-[${layout_gap}]` : '',
    `rounded-md`,
  ].filter(Boolean).join(' ');

  const buttonStyles = {
    fontSize: `${text_font_size}px`,
    fontFamily: text_font_family,
    fontWeight: text_font_weight,
    lineHeight: text_line_height,
    textAlign: text_text_align,
    color: text_color,
    backgroundColor: hasValidBackground ? fill_background : fill_background_color,
    border: hasValidBorder ? border_border : 'none',
    borderRadius: border_border_radius,
    borderImage: hasValidBorderImage ? border_border_image : 'none',
  };

  const handleClick = (event) => {
    if (disabled || loading) return; // ✅ يمنع النقر أثناء التحميل
    if (typeof onClick === 'function') onClick(event);
  };

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={handleClick}
      style={buttonStyles}
      className={twMerge(
        buttonClasses({ variant, size }),
        optionalClasses,
        className
      )}
      aria-disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <span className="flex items-center gap-2">
          <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
          </svg>
          جاري التحميل
        </span>
      ) : (
        children || text
      )}
    </button>
  );
};

export default Button;